module.exports = __webpack_public_path__ + "static/media/friends.0428f63c.svg";